import React from 'react';
import PropTypes from 'prop-types';

import Checkbox from '@component/form/element/checkbox';

export const CookieManagerOption = ({
  handleSelect,
  id,
  title,
  description,
  checked,
  disabled,
}) => (
  <li
    className={`cookie-manager-option cookie-manager-option__option--${id}`}
    data-testid={id}
  >
    <div className="cookie-manager-option__text">
      <h3>{title}</h3>
      <p className="legal__rich-text">{description}</p>
    </div>
    <Checkbox
      className="cookie-manager-option__checkbox"
      name={id}
      checked={checked}
      disabled={disabled}
      onChange={handleSelect}
    />
  </li>
);

CookieManagerOption.propTypes = {
  handleSelect: PropTypes.func,
  id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
};
